import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ChatWidget from "@/components/ChatWidget";
import BackButton from "@/components/BackButton";
import Seo from "@/components/Seo";

export default function SiteLayout() {
  return (
    <SmoothScroll>
      <Seo />
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <BackButton />
    </SmoothScroll>
  );
}
